import { ApplianceType } from '@alpinehomeair/common';
import { XMarkIcon } from '@heroicons/react/24/outline';
import BTUBubbles from 'components/common/btu-bubbles';
import { BTUsType } from 'data/types';

type SpaceInfoCardProps = Readonly<{
  label: string;
  widthFt: number;
  heightFt: number;
  BTUs?: BTUsType;
  showBTUs?: boolean;
  hasSectionColor?: boolean;
  sectionTextColor?: string;
  applianceCount?: number;
  showApplianceCount?: boolean;
  appliances?: ApplianceType[];
  onRemoveAppliance?: (applianceUniqueId: string) => void;
  squareFootage?: number | null;
  showDimensions?: boolean;
}>;

export default function SpaceInfoCard({
  label,
  widthFt,
  heightFt,
  BTUs,
  showBTUs = false,
  hasSectionColor = false,
  sectionTextColor,
  applianceCount = 0,
  showApplianceCount = false,
  appliances = [],
  onRemoveAppliance,
  squareFootage,
  showDimensions = true
}: SpaceInfoCardProps) {
  const dimensionsText =
    squareFootage != null
      ? `${Math.round(squareFootage)} sq ft`
      : `${Math.round(widthFt)}ft × ${Math.round(heightFt)}ft`;
  const labelColor =
    hasSectionColor && sectionTextColor
      ? { color: sectionTextColor }
      : undefined;

  return (
    <div className='flex flex-col items-center gap-1'>
      <div className='font-medium text-black' style={labelColor}>
        {label}
      </div>
      {showApplianceCount ? (
        <div className='flex flex-col items-center gap-1'>
          <div className='text-sm text-gray-500'>
            {applianceCount} {applianceCount === 1 ? 'appliance' : 'appliances'}
          </div>
          {appliances.length > 0 && (
            <ul className='mt-1 w-full text-sm text-gray-600'>
              {appliances.map((appliance) => (
                <li
                  key={appliance.uniqueId}
                  className='flex items-center justify-between gap-2'
                >
                  <span>{appliance.label}</span>
                  {onRemoveAppliance && (
                    <button
                      type='button'
                      className='shrink-0 rounded p-0.5 text-red-500 hover:bg-red-50 hover:text-red-700'
                      onClick={(e) => {
                        e.stopPropagation();
                        onRemoveAppliance(appliance.uniqueId);
                      }}
                    >
                      <XMarkIcon className='h-3.5 w-3.5' />
                    </button>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      ) : (
        showDimensions && (
          <div className='text-xs text-gray-500'>{dimensionsText}</div>
        )
      )}
      {showBTUs && BTUs && <BTUBubbles BTUs={BTUs} abbreviateNumbers />}
    </div>
  );
}
